import { Colors, FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Tag } from "@brg/api";
import { TagItemWrapper } from "../../styles.mobile";
import { DroppableItemContainer } from "./DroppableItemContainer";

const CategoryListWrapper = styled(FlexBox)<{ customHeight?: number, fullWidth?: boolean }>`
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  width: ${({ fullWidth }) => fullWidth ? '100%' : '368px'};
  height: ${p => 'calc(100vh - '+(p?.customHeight || 380)+'px)'};
  padding-bottom: 100px;
  min-width: ${({ fullWidth }) => fullWidth ? 'auto' : '368px'};
  // padding-right: 16px;

  &::-webkit-scrollbar {
    height: 1px;
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }
  
  ${TagItemWrapper} {
    padding-left: 16px;
    margin-left: 0;
    &:hover { 
      background-color: ${({ theme }) => theme.tags.selectedCategory};
    }
    &:after {
      width: 100%;
      left: 0;
    }
  }

  .sortable-list {
    > div {
      width: 100%; 
    }
  }

`

export interface IConvertedTags {
    parent: Tag<'Local'>, 
    hasChild: boolean, 
    children: Tag<'Local'>[]
}

interface CategoryListProps {
  tags: Tag[];
  onCategoryRemove: (tagId: string, type: string) => void;
  onCategoryEdit: (tagId: string, flag?: boolean) => void;
  onUpdatePositions: (categories: { id: string, subCategoryIds: string[]}[]) => void;
  currentCategory: string | null;
  customHeight?: number;
  fullWidth?: boolean;
}

const DroppableCategoryList:FC<CategoryListProps> = ({
  tags,
  onCategoryRemove,
  onCategoryEdit,
  onUpdatePositions,
  customHeight,
  fullWidth
}) => {
  const listRef = useRef<HTMLDivElement>(null);
  const [scrollId, setScrollId] = useState<string | null>(null);
  //@ts-ignore
  const convertTags: IConvertedTags[] = useMemo(() => tags?.reduce((acc, val) => ([
    ...acc,
    {
        parent: val,
        hasChild: val?.additionalTags?.length > 0,
        children: val?.additionalTags
    }
]) , []), [tags]) as IConvertedTags[] 

useEffect(() => {
  if(listRef?.current && scrollId) {
    const el = listRef.current?.querySelector(`[data-id="${scrollId}"]`);
    el?.scrollIntoView({ block: "center", behavior: "smooth" })
  }
}, [listRef, scrollId])

const onSetScrollId = useCallback((id: string) => {
  if (id === scrollId) {
    return;
  }
  setScrollId(id)
} , [scrollId])

  return (
    <CategoryListWrapper ref={listRef} customHeight={customHeight} fullWidth={fullWidth}>
      <DroppableItemContainer 
        tags={convertTags} 
        onRemove={onCategoryRemove} 
        onClick={onCategoryEdit}
        onSetScrollId={onSetScrollId}
        onUpdatePositions={onUpdatePositions} 
      />
    </CategoryListWrapper>
  )
}

export default DroppableCategoryList;import { Colors, FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Tag } from "@brg/api";
import { TagItemWrapper } from "../../styles.mobile";
import { DroppableItemContainer } from "./DroppableItemContainer";

const CategoryListWrapper = styled(FlexBox)<{ customHeight?: number, fullWidth?: boolean }>`
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  width: ${({ fullWidth }) => fullWidth ? '100%' : '368px'};
  height: ${p => 'calc(100vh - '+(p?.customHeight || 380)+'px)'};
  padding-bottom: 100px;
  min-width: ${({ fullWidth }) => fullWidth ? 'auto' : '368px'};
  // padding-right: 16px;

  &::-webkit-scrollbar {
    height: 1px;
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }
  
  ${TagItemWrapper} {
    padding-left: 16px;
    margin-left: 0;
    &:hover { 
      background-color: ${({ theme }) => theme.tags.selectedCategory};
    }
    &:after {
      width: 100%;
      left: 0;
    }
  }

  .sortable-list {
    > div {
      width: 100%; 
    }
  }

`

export interface IConvertedTags {
    parent: Tag<'Local'>, 
    hasChild: boolean, 
    children: Tag<'Local'>[]
}

interface CategoryListProps {
  tags: Tag[];
  onCategoryRemove: (tagId: string, type: string) => void;
  onCategoryEdit: (tagId: string, flag?: boolean) => void;
  onUpdatePositions: (categories: { id: string, subCategoryIds: string[]}[]) => void;
  currentCategory: string | null;
  customHeight?: number;
  fullWidth?: boolean;
}

const DroppableCategoryList:FC<CategoryListProps> = ({
  tags,
  onCategoryRemove,
  onCategoryEdit,
  onUpdatePositions,
  customHeight,
  fullWidth
}) => {
  const listRef = useRef<HTMLDivElement>(null);
  const [scrollId, setScrollId] = useState<string | null>(null);
  //@ts-ignore
  const convertTags: IConvertedTags[] = useMemo(() => tags?.reduce((acc, val) => ([
    ...acc,
    {
        parent: val,
        hasChild: val?.additionalTags?.length > 0,
        children: val?.additionalTags
    }
]) , []), [tags]) as IConvertedTags[] 

useEffect(() => {
  if(listRef?.current && scrollId) {
    const el = listRef.current?.querySelector(`[data-id="${scrollId}"]`);
    el?.scrollIntoView({ block: "center", behavior: "smooth" })
  }
}, [listRef, scrollId])

const onSetScrollId = useCallback((id: string) => {
  if (id === scrollId) {
    return;
  }
  setScrollId(id)
} , [scrollId])

  return (
    <CategoryListWrapper ref={listRef} customHeight={customHeight} fullWidth={fullWidth}>
      <DroppableItemContainer 
        tags={convertTags} 
        onRemove={onCategoryRemove} 
        onClick={onCategoryEdit}
        onSetScrollId={onSetScrollId}
        onUpdatePositions={onUpdatePositions} 
      />
    </CategoryListWrapper>
  )
}

export default DroppableCategoryList;